// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"3a0422668c8b5d52d117","125":"4d925efdb1a232752377","126":"3cdf543b756ccfe5a5e1","174":"09b7c3fa6a09b497a76e"}[chunkId] + ".chunk.js";
};